$(function () {

  $('.course-select').select2({
    placeholder: "Select A Course",
    width: '95%'
  });

  $('.course-select').on("select2:select", function (e) {
    $('.course-desc').hide();
    $('.course-outcomes').hide();
    $('.course-calendly').hide();
    $('#' + e.target.value + '-desc').toggle();
    $('#' + e.target.value + '-outcomes').toggle();
    $('#' + e.target.value + '-calendly').toggle();
  });

});



// WEBPACK FOOTER //
// ./assets/js/courses.js